import React, { useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { ContentTopbar } from "components/shared";
import history from "router/history";
import { toast } from "react-toastify";
import { Profile as AppProfile } from "@low6dev/react-feature-profile/dist";
import { createImageCdnLink } from "@low6dev/react-utils/dist";
import { loadAppStuff } from "components/feature/app/actions";
import { useTranslations, useHandleError, useCheckBalance } from "hooks";
import { getTranslations } from "components/feature/translations/actions";
import { setApp } from "components/feature/app/actions";
import { Card, CardTitle } from "fiver-react-ui-components";

const StyledWrapper = styled.section`
  padding: 1rem 0 0;
`;

const StyledLanguagePicker = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  margin-right: 1.5rem;
  height: 56px;
  font-family: ${(p) => p.theme.fontFamilyDefault};

  ${(p) => p.isInactive && "opacity: 0.25;"};
`;

const StyledFlag = styled.img`
  margin-right: 0.75rem;
  height: 40px;
`;

const Profile = ({ setBetbarParent, betbarParent }) => {
  const dispatch = useDispatch();

  const [translations] = useTranslations();

  const [handleError] = useHandleError();

  const [balance] = useCheckBalance();

  const { isScrolledDown, language } = useSelector((state) => state.app);

  const changeRoute = (path) => {
    history.push(`/${path}`);
  };

  const handleProfileSaveSuccess = (profile) => {
    dispatch(loadAppStuff(profile));
    //toast.success(`${translations.profile} ${translations.saved}`);
  };

  const handleLogoutSuccess = () => {
    localStorage.removeItem("fiver_react_access_token");
    window.location.href = "/";
  };

  const handleLanguageChanged = (language) => {
    dispatch(setApp({ language }));
    dispatch(getTranslations(language));
  };

  const handleProfileError = (error) => {
    // history.push("/login?redirect=profile");
    handleError(error);
  };

  useEffect(() => {
    setBetbarParent({ ...betbarParent, isBetsOpen: false });
    // dispatch(setToolbar({ isBetsOpen: false }));
  }, []);

  return (
    <StyledWrapper>
      <AppProfile
        translations={translations}
        hideLow6Button
        hideAddressTitle
        hideGamblingReferences
        hideVerifyButton={
          process.env.REACT_APP_IS_MOBILE_VERIFICATION_DISABLED === "true"
        }
        hideChangePassword={process.env.REACT_APP_SSO_DISABLED !== "true"}
        hideChangePin
        hideGdprCheckboxes
        showEmailReadonly
        hideLine1
        hidePostcode
        hideCity
        isMinimalAddress
        hideOpenWalletButton={!balance}
        isOpenWalletButtonSpecial
        isScore6
        disableProfileImage
        onLogoutSuccess={handleLogoutSuccess}
        onProfileSaveSuccess={handleProfileSaveSuccess}
        onChangePinClicked={() => changeRoute("change-pin")}
        onChangePasswordClicked={() => changeRoute("change-password")}
        onVerifyMobileClicked={() => changeRoute("verify")}
        onError={handleProfileError}
        isScrolledDown={isScrolledDown}
      />
      {process.env.NODE_ENV === "development" && (
        <Card>
          <CardTitle>{translations.language}</CardTitle>
          <StyledLanguagePicker>
            <StyledButton
              isInactive={language !== "dutch"}
              disabled={language === "dutch"}
              onClick={() => handleLanguageChanged("dutch")}
            >
              <StyledFlag src={createImageCdnLink("flags/Netherlands.png")} />
              Dutch
            </StyledButton>
            <StyledButton
              isInactive={language !== "en"}
              disabled={language === "en"}
              onClick={() => handleLanguageChanged("en")}
            >
              <StyledFlag
                src={createImageCdnLink("flags/United-Kingdom.png")}
              />
              English
            </StyledButton>
          </StyledLanguagePicker>
        </Card>
      )}
    </StyledWrapper>
  );
};

export default Profile;
